

import { Component, Prop, Vue } from 'vue-property-decorator';
import { SmsTemplateInterface } from '@/services/SMS/interfaces';

@Component
export default class DeleteSettingDialog extends Vue {
  @Prop() private readonly template!: SmsTemplateInterface;
  @Prop() private readonly onDelete!: CallableFunction;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove ${this.template.name}?`;
  }

  private destroyComponent(): void {
    this.$emit('close');
  }

  private async deleteSetting(): Promise<void> {
    await this.onDelete(this.template);
    this.destroyComponent();
  }

}
